<template>
  <el-container
    v-loading.fullscreen.lock="
      fullscreenLoading && chatStore.chats && chatStore.chats.length
    "
  >
    <!-- <el-aside width="250px" class="l-chat-box">
			<div class="l-chat-header">
				<el-input width="200px" placeholder="搜索" v-model="searchText">
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<el-scrollbar class="l-chat-list">
				<div v-for="(chat, index) in chatStore.chats" :key="index">
					<chat-item :chat="chat" :index="index" @click.native="handleActiveItem(index)" @del="handleDelItem(chat,index)"
					 :active="index === chatStore.activeIndex"></chat-item>
					<chat-item :chat="chat" :index="index" @click.native="handleActiveItem(index)" :active="index === chatStore.activeIndex"></chat-item>
				</div>
			</el-scrollbar>
		</el-aside> -->
    <el-container class="r-chat-box">
      <chat-box
        v-if="flagByContentBox && isShowFlag"
        :chat="activeChat"
        :yesuser="true"
      ></chat-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
  },
  data() {
    return {
      isShowFlag: false,
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      flagByContentBox: false,
      fullscreenLoading: false,
    };
  },
  methods: {
    handleActiveItem(index) {
      this.$store.commit("activeChat", index);
    },
    handleDelItem(chat, index) {
      this.$store.commit("removeChat", index);
    },
  },
  mounted() {
    //监听是否可以打开数据并阅读
    window.addEventListener("message", (event) => {
      const { type } = event.data;
      if (type === "readingMsg") {
        this.isShowFlag = true;
      } else if (type === "readingNoMsg") {
        this.isShowFlag = false;
      }
    });
    setTimeout(() => {
      this.handleActiveItem(0);
    }, 500);
    this.fullscreenLoading = true;
    setTimeout(() => {
      this.fullscreenLoading = false;
      this.flagByContentBox = true;
    }, 1000);
  },
  computed: {
    accessTokenGet() {
      return sessionStorage.getItem("accessToken");
    },
    chatStore() {
      let userInfoByAdmin = JSON.parse(
        sessionStorage.getItem("systemIdByContent"),
      );
      if (this.$store.state.chatStore.chats.length) {
        let i = this.$store.state.chatStore.chats.findIndex(
          (item) => item.targetId == userInfoByAdmin.id,
        );
        if (i >= 0) {
          this.$store.commit("activeChat", i);
        } else {
          this.$store.commit("openChat", {
            headImage: userInfoByAdmin.headImage,
            showName: "Customer service",
            targetId: userInfoByAdmin.id,
            type: "PRIVATE",
          });
        }
      } else {
        this.$store.commit("openChat", {
          headImage: userInfoByAdmin.headImage,
          showName: "Customer service",
          targetId: userInfoByAdmin.id,
          type: "PRIVATE",
        });
      }
      return this.$store.state.chatStore;
    },
    activeChat() {
      console.log(this.chatStore, "88888888888888");
      let index = this.chatStore.activeIndex;
      let chats = this.chatStore.chats;
      if (index >= 0 && chats.length > 0) {
        return chats[index];
      }
      // 当没有激活任何会话时，创建一个空会话，不然控制台会有很多报错
      let emptyChat = {
        targetId: -1,
        showName: "",
        headImage: "",
        messages: [],
      };
      return emptyChat;
    },
  },
};
</script>

<style lang="scss">
.el-container {
  .l-chat-box {
    display: flex;
    flex-direction: column;
    border: #dddddd solid 1px;
    background: white;
    width: 3rem;

    .l-chat-header {
      padding: 5px;
      background-color: white;
      line-height: 50px;
    }

    .l-friend-ist {
      flex: 1;
    }
  }
  .r-chat-box-mask {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    background-color: r;
  }
}
</style>
